import React from 'react';
import UrlMappings from '../../common/url-mappings';
import {applicationHistory} from '../../common/application-history';
import PropTypes from "prop-types";
import '../style/navigation.scss';

export default class Navigation extends React.Component {
	constructor(props){
		super(props)
	}
	navigateTo(page){
        applicationHistory.push(page);
    }

// const navigateToShop = () => {
// 	window.location = `${process.env.REACT_APP_SHOP_URI}/gifts/ssoentrypoint?isLoggedIn=true`;
// };
//
// const navigateToShopProduct = (product) => {
// 	window.location = `${process.env.REACT_APP_SHOP_URI}/gifts/ssoentrypoint?isLoggedIn=true&selection=null&product=`+product;
// };

	getSelectedClass(pageName) {
        if (applicationHistory.location.pathname.indexOf(`my/${pageName}`) > -1) return 'selected';
        return '';
    }

	getHiddenClass(pageName, hiddenItems){
        if (
            hiddenItems &&
            hiddenItems.indexOf
        )
            return 'hidden';
        return '';
    }
	render() {
        return (
            <div className="left-nav" role="navigation">
                {this.props.customer.acceptedTermsYn === "Y" && <div className="navigation-container">
                    {/*<div className={`navigation-selection-container ${getHiddenClass('timeline', this.props.hiddenItems)} hidden`} aria-labelledby="timeline">*/}
                    {/*<div className={`navigation-selection-item ${getSelectedClass('timeline')}`} />*/}
                    {/*<div className="navigation-button-container" onClick={() => navigateTo(UrlMappings.TIMELINE)}>*/}
                    {/*<div className="navigation-button timeline" />*/}
                    {/*<span>Timeline</span>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {this.props.maintenanceMode !== true &&
                        <div
                            className={`navigation-selection-container ${this.getHiddenClass('album', this.props.hiddenItems)}`}
                            aria-labelledby="albums">
                            <div className={`navigation-selection-item ${this.getSelectedClass('album')}`}/>
                            <div className="navigation-button-container"
                                 onClick={() => this.navigateTo(UrlMappings.ALBUMS)}>
                                <div className="navigation-button album"/>
                                <span>Albums</span>
                            </div>
                        </div>
                    }
                    {this.props.maintenanceMode !== true &&
                    <div
                        className={`navigation-selection-container ${this.getHiddenClass('disc', this.props.hiddenItems)}`}
                        aria-labelledby="discs">
                        <div className={`navigation-selection-item ${this.getSelectedClass('disc')}`}/>
                        <div className="navigation-button-container" onClick={() => this.navigateTo(UrlMappings.DISCS)}>
                            <div className="navigation-button disc"/>
                            <span>Discs</span>
                        </div>
                    </div>
                    }
                    {this.props.cart.cartDataReceived && this.props.cart.orderType !== "RPC" && this.props.maintenanceMode !== true &&
                    <div
                        className={`navigation-selection-container ${this.getHiddenClass('usb', this.props.hiddenItems)}`}
                        aria-labelledby="usbs">
                        <div className={`navigation-selection-item ${this.getSelectedClass('usb')}`}/>
                        <div className="navigation-button-container" onClick={() => this.navigateTo(UrlMappings.USB)}>
                            <div className="navigation-button usb"/>
                            <span>USB Drive</span>
                        </div>
                    </div>
                    }
                    {this.props.maintenanceMode !== true &&
                    <div
                        className={`navigation-selection-container ${this.getHiddenClass('upload', this.props.hiddenItems)}`}
                        aria-labelledby="upload">
                        <div className={`navigation-selection-item ${this.getSelectedClass('upload')}`}/>
                        <div className="navigation-button-container"
                             onClick={() => this.navigateTo(UrlMappings.UPLOAD)}>
                            <div className="navigation-button upload"/>
                            <span>Upload</span>
                        </div>
                    </div>
                    }
                    {this.props.maintenanceMode !== true && this.props.allowDownload === true &&
                        <div
                            className={`navigation-selection-container ${this.getHiddenClass('downloads', this.props.hiddenItems)}`}
                            aria-labelledby="upload">
                            <div className={`navigation-selection-item ${this.getSelectedClass('downloads')}`}/>
                            <div className="navigation-button-container"
                                 onClick={() => this.navigateTo(UrlMappings.DOWNLOADS)}>
                                <div className="navigation-button download"/>
                                <span>Downloads</span>
                            </div>
                        </div>
                    }
                    {/*<div className="nav-hr"></div>*/}
                    <div
                        className={`navigation-selection-container ${this.getHiddenClass('account/storage-plan', this.props.hiddenItems)}`}
                        aria-labelledby="upload">
                        <div className={`navigation-selection-item ${this.getSelectedClass('account/storage-plan')}`}/>
                        <div className="navigation-button-container"
                             onClick={() => this.navigateTo(UrlMappings.SUBSCRIPTION)}>
                            <div className="navigation-button storage-plan"/>
                            <span>Storage Plan</span>
                        </div>
                    </div>
                    <div
                        className={`navigation-selection-container ${this.getHiddenClass('cart', this.props.hiddenItems)}`}
                        aria-labelledby="upload">
                        <div className={`navigation-selection-item ${this.getSelectedClass('cart')}`}/>
                        <div className="navigation-button-container" onClick={() => this.navigateTo(UrlMappings.CART)}>
                            <div className="navigation-button cart"/>
                            <span>Cart{this.props.cart != null && this.props.cart.lineItems != null && this.props.cart.lineItems.length > 0 ?
                                <span className="amber"> ({this.props.cart.numCartItems})</span> : ""}</span>
                        </div>
                    </div>


                    <div
                        className={`navigation-selection-container ${this.getHiddenClass('shop', this.props.hiddenItems)}`}
                        aria-labelledby="shop all">
                        <div className={`navigation-selection-item ${this.getSelectedClass('shop')}`}/>
                        <div className="navigation-button-container" onClick={() => this.navigateTo(UrlMappings.SHOP)}>
                            <div className="navigation-button shop"/>
                            <span>Shop</span>
                        </div>
                    </div>
                    {/*<div className={`navigation-selection-container ${this.getHiddenClass('shop', this.props.hiddenItems)}`} aria-labelledby="order prints">*/}
                    {/*<div className={`navigation-selection-item ${this.getSelectedClass('shop')}`} />*/}
                    {/*<div className="navigation-button-container" onClick={() => this.navigateToShopProduct("prints")}>*/}
                    {/*<div className="navigation-button order-prints" />*/}
                    {/*<span>Order Prints</span>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className={`navigation-selection-container ${this.getHiddenClass('shop', this.props.hiddenItems)}`} aria-labelledby="create books">*/}
                    {/*<div className={`navigation-selection-item ${this.getSelectedClass('shop')}`} />*/}
                    {/*<div className="navigation-button-container" onClick={() => this.navigateToShopProduct("photobooks")}>*/}
                    {/*<div className="navigation-button create-books" />*/}
                    {/*<span>Create Books</span>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className={`navigation-selection-container ${this.getHiddenClass('shop', this.props.hiddenItems)}`} aria-labelledby="make canvas">*/}
                    {/*<div className={`navigation-selection-item ${this.getSelectedClass('shop')}`} />*/}
                    {/*<div className="navigation-button-container" onClick={() => this.navigateToShopProduct("canvasprints")}>*/}
                    {/*<div className="navigation-button make-canvas" />*/}
                    {/*<span>Make Canvas</span>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className={`navigation-selection-container ${this.getHiddenClass('shop', this.props.hiddenItems)}`} aria-labelledby="make cards">*/}
                    {/*<div className={`navigation-selection-item ${this.getSelectedClass('shop')}`} />*/}
                    {/*<div className="navigation-button-container" onClick={() => this.navigateToShopProduct("cards")}>*/}
                    {/*<div className="navigation-button make-cards" />*/}
                    {/*<span>Make Cards</span>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className={`navigation-selection-container ${this.getHiddenClass('shop', this.props.hiddenItems)}`} aria-labelledby="make gifts">*/}
                    {/*<div className={`navigation-selection-item ${this.getSelectedClass('shop')}`} />*/}
                    {/*<div className="navigation-button-container" onClick={() => this.navigateToShopProduct("gifts")}>*/}
                    {/*<div className="navigation-button make-gifts" />*/}
                    {/*<span>Make Gifts</span>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                </div>
                }{/* Agree Terms */}
            </div>
        )
    }
}
Navigation.propTypes = {
    cart: PropTypes.any.isRequired,
    hiddenItems: PropTypes.any,
    maintenanceMode: PropTypes.bool.isRequired,
    customer: PropTypes.any.isRequired,
    allowDownload: PropTypes.bool.isRequired
}


// WEBPACK FOOTER //
// ./src/navigation/components/navigation.jsx